import React from "react";
import { Button } from "react-bootstrap";
import { StyledButton } from "../../assets/styled/styled-components";

const SubmitBtn = ({
  onClick = () => {},
  children,
  isSubmitting,
  variant,
  ...restProps
}) => {
  return (
    <StyledButton
      onClick={onClick}
      variant={variant || "primary"}
      type="submit"
      disabled={isSubmitting}
      {...restProps}
    >
      {isSubmitting && (
        <span
          className="spinner-grow spinner-grow-sm mr-2"
          role="status"
          aria-hidden="true"
        />
      )}
      {children}
    </StyledButton>
  );
};

export const BtnWithLoading = ({
  children,
  isSubmitting,
  variant,
  disabled,
  ...restProps
}) => {
  return (
    <Button
      variant={variant || "primary"}
      disabled={isSubmitting || disabled}
      {...restProps}
    >
      {isSubmitting && (
        <span
          className="spinner-grow spinner-grow-sm mr-2"
          role="status"
          aria-hidden="true"
        />
      )}
      {children}
    </Button>
  );
};

export default SubmitBtn;
